export default __webpack_public_path__ + "static/media/cycle_sport_ks2_tile.7f6d2ff6.jpg";